import FilterStore from "../abstract.filter.store";
import {
    AgencyModuleServiceInterface,
    AgencyModuleStoreInterface,
} from "../../types";
import {
    AgencyAddRequest,
    AgencyEditRequest, AgencyPrepareEditFormRequest, AgencyViewRequest,
} from "../../types/modules/agency/request";
import {ActionEnum, ResponseTypeEnum, TranslationDomainEnum} from "../../types/enums";
import {action, makeObservable, observable, runInAction} from "mobx";
import {UserListItem} from "../../types/modules/user/modules";
import {AppStore} from "../app.store";
import {ApiResponseHandler} from "../../handler/apiResponse.handler";

export default class AgencyStore extends FilterStore implements AgencyModuleStoreInterface {
    public _items: UserListItem[] = [];

    readonly _module: string = 'agency'

    readonly _headers: string[] = [
        'name', 'tpNumber', 'externalId', 'chamberOfCommerceNumber', 'addressString', 'active'
    ]

    public readonly _actions: ActionEnum[] = [
        ActionEnum.VIEW, ActionEnum.EDIT, ActionEnum.VIEW_HISTORY
    ]


    constructor(
        private readonly appStore: AppStore,
        private readonly service: AgencyModuleServiceInterface
    ) {
        super();

        makeObservable(this, {
            _current: observable,
            _pageSize: observable,
            _orderFieldName: observable,
            _orderDirection: observable,
            _headers: observable,
            _items: observable,
            _loading: observable,
            setTablePaginationData: action,
            setTableFilterData: action,
        });
    }

    setTablePaginationData = ({ current, pageSize, field, order }: any) => {
        this.current = current;
        this.pageSize = pageSize;
        this.orderFieldName = field;
        this.orderDirection = order;
    }


    public list = async () => {
        runInAction(() => {
            this.loading = true;
        });

        return this.service.list({
            ...this.searchFields,
            ...this.paginatorRequestParams,
            checkRoutes: this.accessCheckRequestParams
        })
            .then(({data}) => {
                runInAction(() => {
                    this.items = data.data;
                    this.total = data.totalCount;
                    this.loading = false;
                })
            });
    }

    public edit = async (request: AgencyEditRequest) => {
        this.appStore.setLoading(true);
        return this.service.edit(request)
            .then(({data}) => {
                this.appStore.setResponseMessage('agency.message.agency_edit_success', ResponseTypeEnum.SUCCESS, TranslationDomainEnum.COMPANY_ADMINISTRATION)
                return data;
            }).finally(() => {
                this.appStore.setLoading(false);
            });
    }

    public view = async (request: AgencyViewRequest) => {
        return this.service.view(request)
            .then(({data}) => {
                return data;
            });
    }

    public add = async (request: AgencyAddRequest) => {
        this.appStore.setLoading(true);
        return this.service.add(request)
            .then(({data}) => {
                this.appStore.setResponseMessage('agency.message.agency_add_success', ResponseTypeEnum.SUCCESS, TranslationDomainEnum.COMPANY_ADMINISTRATION)
                return data;
            }).finally(() => {
                this.appStore.setLoading(false);
            });
    }

    public prepareEditForm = async (request: AgencyPrepareEditFormRequest) => {
        return this.service.prepareEditForm(request)
            .then(({data}) => {
                return data;
            });
    }

    public prepareAddForm = async () => {
        return this.service.prepareAddForm()
            .then(({data}) => {
                return data;
            });
    }

    public viewHistory = async (request: AgencyViewRequest) => {
        return this.service.viewHistory(request)
            .then(({data}) => {
                return data;
            });
    }
}